import React from 'react'
import '../loader/loader.css'

export default function loader() {
  return (
    <div>
        <div className="animation">
        <div className="ani-child"></div>
      </div>
    </div>
  )
}
